export default "__VITE_ASSET__BgL6pwSO__"